import { Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/use-auth'
import { hasAccessToRoute } from '@/shared/config/permissions'
import { useTranslation } from 'react-i18next'
import { ShieldX } from 'lucide-react'

export function RoleBasedRoute() {
  const { user } = useAuth()
  const location = useLocation()
  const { t } = useTranslation()

  if (!user || !hasAccessToRoute(user.role, location.pathname)) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4 p-8 text-center">
        <ShieldX className="h-16 w-16 text-neutral-400" />
        <h2 className="text-xl font-semibold text-neutral-700">
          {t('common.error', 'Accès refusé')}
        </h2>
        <p className="text-sm text-neutral-500">
          Vous n'avez pas les permissions nécessaires pour accéder à cette page.
        </p>
      </div>
    )
  }

  return <Outlet />
}
